import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogContent,
  FormControlLabel,
  Grid,
  IconButton,
  makeStyles,
  withStyles,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@material-ui/core';
import { useRoutes } from 'hookrouter';
import { useEffect, useRef, useState } from 'react';
import Routes from '../routes/routes';
import NavBar from '../NavBar/navbar';
import { navigate } from 'hookrouter';
import LinearProgress from '@material-ui/core/LinearProgress';
import axios from 'axios';
import VisibilityIcon from '@material-ui/icons/Visibility';

import { gridColumnLookupSelector } from '@material-ui/data-grid';

const BorderLinearProgress = withStyles((theme) => ({
  root: {
    height: 10,
    borderRadius: 5,
  },
  colorPrimary: {
    backgroundColor: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
  },
  bar: {
    borderRadius: 5,
    backgroundColor: '#1a90ff',
  },
}))(LinearProgress);

const useStyles = makeStyles((theme) => ({
  wrap: {
    margin: theme.spacing(4),
  },
  header: {
    textAlign: 'center',
    margin: theme.spacing(3),
  },
  btn: {
    display: 'flex',
    float: 'right',
    marginRight: '30px',
  },
  rowBtn: {
    margin: theme.spacing(1),
  },
  dialogBox: {
    padding: theme.spacing(1),
    textAlign: 'center',
  },
  root: {
    padding: theme.spacing(3),
    '& .MuiFormControl-root': {
      width: '100%',
      textAlign: 'left',
      padding: '0',
    },
  },
}));

const columns = [
  { id: 'id', label: 'Filename', minWidth: 170 },
  { id: 'person', label: 'Uploader', minWidth: 70 },
  { id: 'template', label: 'Template', minwidth: 170 },
  { id: 'Createdon', label: 'Created on', minWidth: 170 },
  { id: 'rows', label: 'Total number of rows', minWidth: 50 },
  { id: 'uploaded', label: 'Uploaded rows', minWidth: 50 },
  { id: 'progress', label: 'Progress', minWidth: 170 },
  { id: 'percentage', label: 'Percentage Uploaded', minWidth: 50 },
  { id: 'status', label: 'Status', minWidth: 50 },
  { id: 'TimeTaken', label: 'Time Taken', minWidth: 170 },
  { id: 'EstimatedTime', label: 'Estimated Time', minWidth: 170 },
];

export default function UploadProgress(props) {
  useRoutes(Routes);

  const classes = useStyles();

  const api = '/api/';
  const [progressState, setprogressState] = useState([]);
  const [message, setmessage] = useState('Fetching data');
  const [timer, settimer] = useState('');
  const [progressLoader, setprogressLoader] = useState(true);

  if (localStorage.getItem('auth') !== 'true') {
    navigate('/', true);
  }

  useEffect(() => {
    window.onpopstate = () => {
      clearInterval(timer);
      settimer('');
      setprogressState([]);
    };
  });

  useEffect(() => {
    if (progressState.length !== 0) {
      setprogressLoader(false);
    }
  }, [progressState]);

  useEffect(() => {
    if (localStorage.getItem('auth') !== 'true') {
      navigate('/', true);
    }

    axios
      .get(api + 'uploadprogress/fortemplate/?templateId=' + props.customerID)
      .then((response) => {
        var jsonResponse = response.data;

        if (jsonResponse.length === 0) {
          setmessage('No data available');
          return;
        }

        let uploads = [];

        for (let i = 0; i < jsonResponse.length; i++) {
          if (jsonResponse[i].status != 'Completed') {
            uploads.push(jsonResponse[i].id);
          }
        }
        if ('uploads' in localStorage) {
          let currentUploads = JSON.parse(localStorage.getItem('uploads'));
          for (let i = 0; i < uploads.length; i++) {
            if (!currentUploads.includes(uploads[i])) {
              currentUploads.push(uploads[i]);
            }
          }
          localStorage.setItem('uploads', JSON.stringify(currentUploads));
        } else {
          localStorage.setItem('uploads', JSON.stringify(uploads));
        }
        setprogressState(jsonResponse);
      })
      .catch((error) => {
        console.log('Fetch data types error');
      });

    fetchlatest();
  }, []);

  const displayTime = (start, end) => {
    var timeStart = new Date(start).getTime();
    var timeEnd = new Date(end).getTime();
    var hourDiff = timeEnd - timeStart; //in ms
    var secDiff = hourDiff / 1000; //in s
    var minDiff = hourDiff / 60 / 1000; //in minutes
    var hDiff = hourDiff / 3600 / 1000; //in hours
    var humanReadable = {};
    humanReadable.hours = Math.floor(hDiff);
    humanReadable.minutes = minDiff - 60 * humanReadable.hours;
    if (humanReadable.hours === 0) {
      return Math.ceil(humanReadable.minutes) + ' Minutes';
    } else {
      return (
        Math.ceil(humanReadable.hours) + ' Hours : ' + Math.ceil(humanReadable.minutes) + ' Minutes'
      );
    }
  };

  const displaySeconds = (seconds) => {
    var sec_num = parseInt(seconds);
    var hours = Math.floor(sec_num / 3600);
    var minutes = Math.floor((sec_num - hours * 3600) / 60);
    var seconds = sec_num - hours * 3600 - minutes * 60;

    if (hours < 10) {
      hours = '0' + hours;
    }
    if (minutes < 10) {
      minutes = '0' + minutes;
    }
    if (seconds < 10) {
      seconds = '0' + seconds;
    }
    if (hours === 0) {
      return minutes + 'Minutes : ' + seconds + 'Seconds';
    } else {
      return hours + ' H ' + minutes + ' M ' + seconds + ' S';
    }
  };

  const fetchlatest = () => {
    let timeHandler = setInterval(() => {
      if (localStorage.getItem('auth') !== 'true') {
        navigate('/', true);
      }

      axios
        .get(api + 'uploadprogress/fortemplate/?templateId=' + props.customerID)
        .then((response) => {
          var jsonResponse = response.data;

          if (jsonResponse.length === 0) {
            setmessage('No data available');
            return;
          }

          let uploads = [];
          for (let i = 0; i < jsonResponse.length; i++) {
            if (jsonResponse[i].status != 'Completed') {
              uploads.push(jsonResponse[i].id);
            }
          }

          console.log(uploads);

          if ('uploads' in localStorage) {
            let currentUploads = JSON.parse(localStorage.getItem('uploads'));
            for (let i = 0; i < uploads.length; i++) {
              if (!currentUploads.includes(uploads[i])) {
                currentUploads.push(uploads[i]);
              }
            }

            localStorage.setItem('uploads', JSON.stringify(currentUploads));
          } else {
            localStorage.setItem('uploads', JSON.stringify(uploads));
          }
          setprogressState(jsonResponse);
        })
        .catch((error) => {
          console.log('Fetch data types error');
          console.log(error);
        });
    }, 5000);

    settimer(timeHandler);
    localStorage.setItem('Handler', JSON.stringify(timeHandler));
  };

  return (
    <>
      <NavBar />
      <div style={{ margin: '20px' }}>
        <Button
          variant="outlined"
          startIcon={<VisibilityIcon />}
          color="default"
          onClick={() => {
            clearInterval(timer);
            settimer('');
            navigate('/template/' + localStorage.getItem('userId'));
            setprogressState([]);
          }}
        >
          View Existing Templates
        </Button>
      </div>
      {progressState.length === 0 && (
        <Typography variant="h5" style={{ marginTop: '20px' }}>
          {message}
        </Typography>
      )}
      {progressState.length !== 0 && progressLoader === false && (
        <>
          <Paper className={classes.wrap}>
            <TableContainer>
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {columns.map((column) => (
                      <TableCell
                        key={column.id}
                        align={column.align}
                        style={{ minWidth: column.minWidth }}
                      >
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {progressState
                    ? progressState.map((row) => {
                        return (
                          <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                            <TableCell>{unescape(row.filename)}</TableCell>
                            <TableCell>{row.username}</TableCell>
                            <TableCell>{row.template.customer.name}</TableCell>
                            <TableCell>{new Date(row.createdOn).toLocaleString()}</TableCell>
                            <TableCell>{row.valueMax}</TableCell>
                            <TableCell>{row.valueNow}</TableCell>
                            <TableCell>
                              <BorderLinearProgress
                                variant="determinate"
                                value={Math.ceil((row.valueNow / row.valueMax) * 100)}
                              />
                            </TableCell>
                            <TableCell>{Math.ceil((row.valueNow / row.valueMax) * 100)}%</TableCell>
                            <TableCell>{row.status}</TableCell>
                            <TableCell>
                              {row.status === 'Completed'
                                ? displayTime(row.createdOn, row.updatedOn)
                                : '-'}
                            </TableCell>
                            <TableCell>
                              {row.status !== 'Completed' ? displaySeconds(row.eta) : '-'}
                            </TableCell>
                          </TableRow>
                        );
                      })
                    : 'No Data to Display'}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </>
      )}
      <Dialog open={progressLoader}>
        <DialogContent style={{ overflow: 'hidden', textAlign: 'center' }}>
          <CircularProgress />
          <Typography variant="h6">Fetching Uploads</Typography>
        </DialogContent>
      </Dialog>
    </>
  );
}
